var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1025 50.6667C16.0284 50.6667 15.1316 50.307 14.4122 49.5875C13.6927 48.8681 13.333 47.9713 13.333 46.8972V17.1028C13.333 16.0287 13.6927 15.132 14.4122 14.4125C15.1316 13.6931 16.0284 13.3333 17.1025 13.3333H46.8968C47.971 13.3333 48.8677 13.6931 49.5872 14.4125C50.3066 15.132 50.6663 16.0287 50.6663 17.1028V46.8972C50.6663 47.9713 50.3066 48.8681 49.5872 49.5875C48.8677 50.307 47.971 50.6667 46.8968 50.6667H17.1025ZM17.1025 48.3333H46.8968C47.2562 48.3333 47.5854 48.1838 47.8844 47.8848C48.1835 47.5857 48.333 47.2565 48.333 46.8972V17.1028C48.333 16.7435 48.1835 16.4143 47.8844 16.1153C47.5854 15.8162 47.2562 15.6667 46.8968 15.6667H17.1025C16.7432 15.6667 16.414 15.8162 16.1149 16.1153C15.8159 16.4143 15.6663 16.7435 15.6663 17.1028V46.8972C15.6663 47.2565 15.8159 47.5857 16.1149 47.8848C16.414 48.1838 16.7432 48.3333 17.1025 48.3333ZM23.3844 42.5H40.9743C41.3511 42.5 41.6262 42.331 41.7997 41.9931C41.9731 41.6551 41.9492 41.3215 41.7279 40.9921L37.0163 34.6612C36.813 34.4096 36.5617 34.2838 36.2627 34.2838C35.9632 34.2838 35.7118 34.4096 35.5084 34.6612L30.1598 41.4232L26.8302 37.3982C26.6268 37.1769 26.3831 37.0663 26.0993 37.0663C25.815 37.0663 25.5711 37.1919 25.3678 37.4431L22.6751 40.9921C22.4239 41.3215 22.385 41.6551 22.5584 41.9931C22.7323 42.331 23.0076 42.5 23.3844 42.5Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/DefaultImage.35ac3b9b5c41ecc86a86fbcb16977a29.svg";
export { ForwardRef as ReactComponent };